import React from 'react';
import { MessageCircle, Phone, Instagram, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const whatsappNumber = "18099640099";

  return (
    <footer className="bg-black border-t border-yellow-700/20">
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 lg:px-20 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Column 1 - Brand */}
          <div>
            <img 
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_1bd442c9-79ae-4fe7-8ae4-14527c6bbbf8/artifacts/eah2h1s1_logo%20empresa.jpeg"
              alt="La Rent Car de la Isla"
              className="h-12 object-contain mb-6"
            />
            <p className="text-white/70 leading-relaxed mb-6">
              Tu mejor opción para alquilar vehículos en República Dominicana. 
              Servicio especializado para turistas.
            </p>
            <div className="flex gap-4">
              <a 
                href={`https://wa.me/${whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-yellow-700/20 border border-yellow-700/30 flex items-center justify-center hover:bg-yellow-700 transition-colors duration-300 group"
              >
                <MessageCircle className="w-5 h-5 text-yellow-600 group-hover:text-black" />
              </a>
              <a 
                href="https://instagram.com/rentcardelaisla"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-yellow-700/20 border border-yellow-700/30 flex items-center justify-center hover:bg-yellow-700 transition-colors duration-300 group"
              >
                <Instagram className="w-5 h-5 text-yellow-600 group-hover:text-black" />
              </a>
              <a 
                href="tel:+18099640099"
                className="w-10 h-10 bg-yellow-700/20 border border-yellow-700/30 flex items-center justify-center hover:bg-yellow-700 transition-colors duration-300 group"
              >
                <Phone className="w-5 h-5 text-yellow-600 group-hover:text-black" />
              </a>
              <a 
                href="mailto:larentcardelaisla@gmail.com"
                className="w-10 h-10 bg-yellow-700/20 border border-yellow-700/30 flex items-center justify-center hover:bg-yellow-700 transition-colors duration-300 group"
              >
                <Mail className="w-5 h-5 text-yellow-600 group-hover:text-black" />
              </a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Enlaces Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => document.getElementById('vehiculos').scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/70 hover:text-yellow-600 transition-colors duration-300"
                >
                  Vehículos Disponibles
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('faq').scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/70 hover:text-yellow-600 transition-colors duration-300"
                >
                  Preguntas Frecuentes
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('contacto').scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/70 hover:text-yellow-600 transition-colors duration-300"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3 - Services */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Servicios</h3>
            <ul className="space-y-3 text-white/70">
              <li>Alquiler SUV</li>
              <li>Vehículos de Lujo</li>
              <li>Entrega en Aeropuerto</li>
              <li>Entrega en Hoteles</li>
              <li>Servicio 24/7</li>
              <li>Atención Multiidioma</li>
            </ul>
          </div>

          {/* Column 4 - Contact */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6">Contacto</h3>
            <ul className="space-y-4">
              <li>
                <a 
                  href={`https://wa.me/${whatsappNumber}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-yellow-600 transition-colors duration-300 flex items-start gap-2"
                >
                  <MessageCircle className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <div>
                    <div className="font-semibold text-white text-sm mb-1">WhatsApp</div>
                    <div>+1 (809) 964-0099</div>
                  </div>
                </a>
              </li>
              <li>
                <a 
                  href="tel:+18099640099"
                  className="text-white/70 hover:text-yellow-600 transition-colors duration-300 flex items-start gap-2"
                >
                  <Phone className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <div>
                    <div className="font-semibold text-white text-sm mb-1">Teléfono</div>
                    <div>+1 (809) 964-0099</div>
                  </div>
                </a>
              </li>
              <li>
                <a 
                  href="https://instagram.com/rentcardelaisla"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-yellow-600 transition-colors duration-300 flex items-start gap-2"
                >
                  <Instagram className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <div>
                    <div className="font-semibold text-white text-sm mb-1">Instagram</div>
                    <div>@rentcardelaisla</div>
                  </div>
                </a>
              </li>
              <li>
                <a 
                  href="https://tiktok.com/@rentcardelaisla"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-yellow-600 transition-colors duration-300 flex items-start gap-2"
                >
                  <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                  </svg>
                  <div>
                    <div className="font-semibold text-white text-sm mb-1">TikTok</div>
                    <div>@rentcardelaisla</div>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-yellow-700/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm text-center md:text-left">
              © {currentYear} La Rent Car de la Isla. Todos los derechos reservados.
            </p>
            <p className="text-white/60 text-sm text-center md:text-right">
              Servicio de alquiler de vehículos en República Dominicana
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
